<template>
    <new-modal title="Convert student to group membership" size="4xl" ref="convertSelfManagedStudentModal">
        <template #trigger>
            <div class="btn btn-warning btn-sm">
                <div class="flex items">Manage in Group</div>
            </div>
        </template>
        <template #content>
            This action will cancel the student's existing self-managed subscription, remove
            their payment methods from EMTprep's system and allow you to extend them using a
            group membership. They will retain any remaining time on their current subscription.
        </template>
        <template #controls>
            <div class="flex w-full justify-end gap-4">
                <div class="btn btn-outline" @click="closeModal">Cancel</div>
                <div
                    class="btn btn-primary"
                    @click="convertStudent"
                >
                    Yes, convert {{ student.full_name }}
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal"

export default {
    name: 'group-convert-self-managed-student-to-group-managed-modal',
    components: {NewModal},
    props: {
        student: {}
    },
    methods: {
        closeModal() {
            this.$refs.convertSelfManagedStudentModal.closeModal()
        },
        convertStudent() {
            this.$inertia.post(
                route('group-backend.students.convert-self-managed', this.student.id)
            )
        }
    },
}
</script>
